module.exports = __webpack_public_path__ + "img/saizi6.52201ef2.png";